import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { TextLink } from '../../../../../common/html/TextLink'
import { isValidNumber } from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { COMPONENTS } from '../../../../../routers/constants'
import { USER_TYPE } from '../../../../../utils/authorization'
import { Score } from '../../score'
import { TRENDING } from '../constant'
import classes from './index.module.scss'

const getLabelAndIconScore = (score, prevScore) => {
  if (!isValidNumber(score)) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_NOT_AVAILABLE', icon: '' }
  }

  if (!isValidNumber(prevScore)) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_FIRST_TIME', icon: '' }
  }

  if (score === prevScore) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_STABLE', icon: '' }
  }

  if (score < prevScore) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_DOWN', icon: 'south-east' }
  }

  return { label: 'CREDIT_RISK_SCORE_LABEL_UP', icon: 'north-east' }
}

const getLabelAndIconScoreNeedUpgrade = (trending) => {
  if (trending === TRENDING.FIRST_SCORE) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_FIRST_TIME', icon: '' }
  }
  if (trending === TRENDING.INCREASE) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_UP', icon: 'north-east' }
  }
  if (trending === TRENDING.DECREASE) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_DOWN', icon: 'south-east' }
  }
  if (trending === TRENDING.SIDEWAY) {
    return { label: 'CREDIT_RISK_SCORE_LABEL_STABLE', icon: '' }
  }

  return { label: 'CREDIT_RISK_SCORE_LABEL_NOT_AVAILABLE', icon: '' }
}

export const Content = ({
  score,
  prevScore,
  isHiddenTextLink,
  appendStyle,
  styleIcon,
  dataWhenDisable,
  scoreColor,
}) => {
  const location = useLocation()
  const userType = useSelector(selectUserType)

  const disableNeedUpgrade = [USER_TYPE.STANDARD, USER_TYPE.LITE].includes(
    userType.userTypeId,
  )

  const { icon, label } = disableNeedUpgrade
    ? getLabelAndIconScoreNeedUpgrade(dataWhenDisable?.trending)
    : getLabelAndIconScore(score, prevScore)

  return (
    <div className={classes.container}>
      <Score
        score={score}
        appendStyle={appendStyle}
        styleIcon={styleIcon}
        icon={icon}
        color={
          disableNeedUpgrade
            ? dataWhenDisable?.color || '#CCCCCC'
            : scoreColor || '#CCCCCC'
        }
        disableNeedUpgrade={disableNeedUpgrade}
      />
      {!isHiddenTextLink && (
        <span className={classes.value}>
          <TextLink
            id="creditRiskScore"
            value={`companyAnalysis.common.${label}`}
            labelLink="companyAnalysis.common.CREDIT_RISK_SCORE"
            url={
              COMPONENTS.companyAnalysis.components.score.components
                .corporateRiskScore.route + location.search
            }
          />
        </span>
      )}
    </div>
  )
}

Content.propTypes = {
  score: PropTypes.number,
  prevScore: PropTypes.number,
  isHiddenTextLink: PropTypes.bool,
  appendStyle: PropTypes.object,
  styleIcon: PropTypes.object,
  dataWhenDisable: PropTypes.object,
}

Content.defaultProps = {
  isHiddenTextLink: false,
  appendStyle: {},
  styleIcon: {},
  dataWhenDisable: {},
}
